{
  "change-image": "Change Image",
  "upload-image": "Upload Image",
  "uploading": "Uploading {{count}}%",
  "transcoding": "Transcoding {{count}}%",
  "problem-previewing-this-document": "Problem previewing this document",
  "try-to-download-or-replace-this-item": "Try to download or replace this item",
  "download": "Download",
  "replace": "Replace",
  "pdf-file-upload-limit": "Only .pdf (Maximum size 200 MB)",
  "upload-from-device": "Upload from your device",
  "try-again": "Try again",
  "something-went-wrong": "Something went wrong. Image could not be uploaded.",
  "image-too-large": "Image is too large. Maximum size 4 MB.",
  "something-wrong": "Something went wrong",
  "video-preview-error": "Your video could not be uploaded. Try again or start over if that doesn’t do the trick."
}
